import Vue from 'vue'
import FontPicker from 'font-picker-vue'

Vue.component('font-picker', FontPicker)
